import * as React from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { IMapOptions } from "../interfaces/mapoptions";
import { useAppSelector } from "../store/index";
import { RootState } from "../reducers/index";
import { composePathRoot } from "../api/utility";
import PoiDetailsAddress from "./poidetailsaddress";
import PoiDetailsCategory from "./poidetailscategory";
import YelpStars from "./yelpstars";
import { PoiSearch } from "../api/poisearch";

interface IPoiDetailsProps {
    poiData: PoiSearch;
}

const PoiDetails = ({ poiData }: IPoiDetailsProps) => {
    const { adr1, adr2, poiname, travel } = useParams();
    const navigate = useNavigate();
    const mapoptions = useAppSelector<IMapOptions>((x: RootState) => x.mapoptions);

    if (!poiData) {
        return (<div className="spinner"><div className="double-bounce1" /><div className="double-bounce2" /></div>);
    }
    const result = poiData.result;
    const poiindex = poiData.poiindex;
    const title = result.name || 'Point of Interest';
    const location = result.location;
    const addressLines = location.displayAddress.map(function (adr, idx) {
        return (<PoiDetailsAddress addressline={adr} key={idx} />);
    });

    let categoryLines: Array<JSX.Element> = null;
    if (result.categories) {
        categoryLines = result.categories.map(function (category, idx) {
            console.log(mapoptions.code);
            const poiLink = mapoptions.basename + composePathRoot(adr1, adr2, category.title, travel, mapoptions.code);
            return (<PoiDetailsCategory category={category.title} key={idx} link={poiLink} />);
        });
    }

    /* Larger images http://stackoverflow.com/questions/17965691/yelp-api-ios-getting-a-larger-image */

    let imageStyle = {};

    if (result.imageUrl) {
        const imageurl = result.imageUrl.replace("ms.jpg", "l.jpg");
        imageStyle["backgroundImage"] = 'url(' + imageurl + ')';
    }

    let phone: JSX.Element = null;
    if (result.phone) {
        const phonelink = "tel:" + result.phone;
        phone = (<div className="phone">
            <i className="material-icons">local_phone</i>
            <span itemProp="telephone"><a href={phonelink}>{result.phone}</a></span>
        </div>);
    }

    const reviewname = result.reviewCount === 1 ? "review" : "reviews";

    const headerClassName = "place-header data poi-item" + poiindex;

    const reviewurl = result.url;

    const urlroot = composePathRoot(adr1, adr2, poiname, travel, mapoptions.code);

    return (<div className="pois-container details-container">
        <article className="poi-details" itemScope itemType="http://schema.org/LocalBusiness">
            <span onClick={() => navigate(-1)} className="back-to-results"><i className="material-icons">close</i></span>
            <div className="poi-details-head">
                <div className="poi-details-image">
                    <meta itemProp="image" content={result.imageUrl} />
                    <div className="place-image" style={imageStyle} />
                </div>
                <div className="poi-details-data">
                    <div className={headerClassName}>
                        <div className='pin-title'>
                            <div className="pin-index">{poiindex}</div>
                            <div className="pin-name"><h3>{title}</h3></div>
                        </div>

                        <div className="clearfix" />
                        <div className="reviews">
                            <div className="stars">
                                <YelpStars rating={result.rating} />
                            </div>
                            <div className="count">
                                <a href={reviewurl} target="_blank">{result.reviewCount} {reviewname}</a>
                            </div>
                        </div>
                        <div className="clearfix" />
                        <div className="address" itemProp="address" itemScope itemType="http://schema.org/PostalAddress">
                            <i className="material-icons">place</i>
                            <span itemProp="streetAddress">{addressLines}</span>
                            <span itemProp="addressLocality" className="city">{location.city}</span>
                            <span className="comma">,&nbsp;</span>
                            <span itemProp="addressRegion" className="state">{location.state}&nbsp;</span>
                            <span itemProp="postalCode" className="zipcode">{location.zipCode}</span>
                        </div>
                        {phone}
                        <div className="link">
                            <i className="material-icons">public</i>
                            <span><a href={reviewurl} target="_blank">View on Yelp</a></span>
                        </div>
                        <div className="categories">
                            <i className="material-icons">label_outline</i>
                            <ul>
                                {categoryLines}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div className="clearfix" />
        </article>
        <div className="powered-by" />
    </div>);
};

export default PoiDetails;

